/* eslint-disable react/prop-types */
import { Menu } from "antd";
import Sider from "antd/es/layout/Sider";
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { TbClipboardText } from "react-icons/tb";
import { LiaAngleLeftSolid } from "react-icons/lia";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import axios from "axios";
import { FaBars } from "react-icons/fa";
const ClassSidebar = ({ collapsed }) => {
  const { pathname } = useLocation();
  const mainPath = pathname?.split("/")[4];
  const defaultRoute =
    mainPath?.slice(0).charAt(0).toUpperCase() + mainPath?.slice(1);

  const { classId } = useParams();
  const [broadcastId, setBroadcastId] = useState(null)
  const swapSettingsQuestion = useSelector((state) => state.examSidebar.value);
  const toggleShuffle = useSelector((state) => state.omrToggle.value);
  const navigate = useNavigate();
  const apiUrl = import.meta.env.VITE_APP_API;
  const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))?.token?.access;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const startStreaming = (classId) => {
    navigate();
  };


  const fetchVideoDetails = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/streaming/video_settings/${classId}`, {
        headers: { Authorization: `Bearer ${access_token}` },
      });
      console.log(response.data);

      setBroadcastId(response.data.broadcast)
    } catch (error) {
      console.log("Error fetching video details:", error);
    }
  };
  useEffect(() => {
    fetchVideoDetails();
  }, [classId]);

  let sidebarItems = [
    {
      key: "Settings",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/admin/class_list/${classId}/settings`}
          className="text-base font-semibold"
        >
          Settings
        </NavLink>
      ),
      path: `/admin/class_list/${classId}/settings`,
    },
    {
      key: "Streaming",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/${classId}/stream`}
          className="text-base font-semibold"
        >
          Streaming
        </NavLink>
      ),
      path: `/${classId}/stream`,
    },
    {
      key: "view",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/admin/class_list/${classId}/view`}
          className="text-base font-semibold"
        >
          View
        </NavLink>
      ),
      path: `/admin/class_list/${classId}/view`,
    },

    {
      key: "Publish",
      icon: <TbClipboardText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to={`/admin/class_list/${classId}/publish`}
          className="text-base font-semibold"
        >
          Publish
        </NavLink>
      ),
      path: `/admin/class_list/${classId}/publish`,
    },
  ];

  if (swapSettingsQuestion === true) {
    [sidebarItems[0], sidebarItems[1]] = [sidebarItems[1], sidebarItems[0]];
  }

  return (
    <div className={`fixed md:static lg:static ${isMobile && !collapsed ? "w-64" : isMobile ? "hidden" : collapsed ? "w-16" : "w-64"} h-[calc(100vh-64px)] bg-gray-100 transition-all duration-300 shadow-lg ${isMobile ? "z-50" : ""}`}>
      <nav className="mt-4">
        <Link
          to="/admin/classes"
          className="flex gap-2 items-center px-5 py-3 text-base font-semibold hover:bg-gray-200"
        >
          <LiaAngleLeftSolid />
          {!collapsed && "Classes"}
        </Link>
        <ul className="mt-4 text-base font-semibold">
          {sidebarItems.map((item) => {
            if (item.key === "Streaming" && broadcastId === null) return null; // Skip Streaming if no broadcastId

            return (
              <li key={item.key} className={`px-5 py-3 hover:bg-gray-200 ${defaultRoute === item.key ? "bg-gray-300" : ""}`}>
                <Link to={item.path} className="flex items-center gap-2">
                  {item.icon}
                  {!collapsed && item.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default ClassSidebar;
